import React from "react";
import AbousUsContainer from "../containers/about-us-container";

const AboutUsPage = () => (
  <main className="about_page">
    <AbousUsContainer />
  </main>
);

export default AboutUsPage;
